import { render, staticRenderFns } from "./hvorfor.vue?vue&type=template&id=d454fdec&"
import script from "./hvorfor.vue?vue&type=script&lang=js&"
export * from "./hvorfor.vue?vue&type=script&lang=js&"
import style0 from "./hvorfor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports